import React from 'react';
import { FaInstagram, FaFacebook } from 'react-icons/fa'; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="social-media">
        <a href="https://www.instagram.com/higherlowfilms/" target="_blank" rel="noopener noreferrer" className="social-link">
          <FaInstagram /> 
        </a>
        <a href="https://www.facebook.com/higherlowfilms/" target="_blank" rel="noopener noreferrer" className="social-link">
          <FaFacebook /> 
        </a>
      </div>
      <p className="copyright">&copy; 2021-2025 Higher Low Films LLC</p>
    </footer>
  );
};

export default Footer;